module.exports = __webpack_public_path__ + "media/entities/1004-7d59543c.png";